const ActionTypes = {
  LOGOUT: 'Logout',
  LOGIN: 'Login',
  REDIRECT: 'Redirect',
  GET_PERMISSIONS: 'Get Permissions',
  SET_AUTHENTICATED: 'Set authenticated',
  RESET_PASSWORD: 'Reset password',
  CHANGE_PASSWORD: 'Change password',
  CREATE_SALESFORCE: 'Creating Salesforce User'
};

export default ActionTypes;
